import { useRouter } from 'next/router';
import React from 'react';
import useIsMobile from '@/hooks/useIsMobile';
import HeartIcon from './icons/HeartIcon';
const WishlistEntryPoint = () => {
  const {
    push
  } = useRouter();
  const {
    isMobile
  } = useIsMobile();
  return isMobile ? <div className="p-2 border border-gray-200 rounded-lg" data-sentry-component="WishlistEntryPoint" data-sentry-source-file="WishlistEntryPoint.tsx">
      <HeartIcon width={21} height={21} onClick={() => push('/wishlist')} data-sentry-element="HeartIcon" data-sentry-source-file="WishlistEntryPoint.tsx" />
    </div> : <div className="p-2 border border-gray-200 rounded-lg" data-sentry-component="WishlistEntryPoint" data-sentry-source-file="WishlistEntryPoint.tsx">
      <HeartIcon width={21} height={21} onClick={() => push('/wishlist')} data-sentry-element="HeartIcon" data-sentry-source-file="WishlistEntryPoint.tsx" />
    </div>;
};
export default WishlistEntryPoint;